import { render, staticRenderFns } from "./AssembleTheNumberPreview.vue?vue&type=template&id=180c6402&lang=pug&"
import script from "./AssembleTheNumberPreview.vue?vue&type=script&lang=js&"
export * from "./AssembleTheNumberPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports